import React from "react";
import Typography from "@material-ui/core/Typography";
interface SubTitleProps {
  children: any;
}
const SubTitle: React.FC<SubTitleProps> = ({ children }) => {
  return (
    <Typography component="h2" variant="subtitle1" color="primary" gutterBottom>
      {children}
    </Typography>
  );
};

export default SubTitle;
